import { render, staticRenderFns } from "./StationTakeDialog.vue?vue&type=template&id=5877ea4a"
import script from "./StationTakeDialog.vue?vue&type=script&lang=js"
export * from "./StationTakeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports